import React, { PropsWithChildren, ReactNode } from 'react';
import { IconButton, Tooltip, TooltipProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface Props {
  /** Tooltip title */
  readonly title: ReactNode;
  /** Tooltip placement */
  readonly placement?: TooltipProps['placement'];
  /** Whether the tooltip's interactivity is enabled (disabled by default) */
  readonly enableInteractive?: boolean;
  /** Button click handler */
  readonly onClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** Whether the button is disabled */
  readonly disabled?: boolean;
  /** Button size */
  readonly size?: 'small' | 'medium' | 'large';
  /** Button styling */
  readonly sx?: SxProps<Theme>;
}

/** An icon button with a tooltip. The tooltip is available even when the button is disabled. */
export const TooltipIconButton = ({
  title,
  onClick,
  disabled,
  placement,
  enableInteractive,
  size,
  sx,
  children,
}: PropsWithChildren<Props>) => (
  <Tooltip title={title} placement={placement} disableInteractive={!enableInteractive}>
    <span>
      <IconButton onClick={onClick} disabled={disabled} size={size} sx={sx}>
        {children}
      </IconButton>
    </span>
  </Tooltip>
);
